var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRanking(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 15.676L8.667 16.69c-.137.1-.27.104-.396.01-.127-.093-.168-.222-.124-.386l.524-1.66-1.312-.91c-.137-.101-.181-.229-.134-.384.048-.155.16-.232.34-.232h1.568l.495-1.616-2.832-2.118a1.377 1.377 0 01-.471-.543 1.532 1.532 0 01-.165-.681V3.58c0-.374.13-.69.39-.95s.576-.39.95-.39h5c.374 0 .69.13.95.39s.39.576.39.95v4.59c0 .225-.058.45-.173.675a1.338 1.338 0 01-.48.533l-2.815 2.134.495 1.616h1.569c.178 0 .291.077.339.232.047.155.003.283-.134.383l-1.313.91.524 1.66c.045.165.004.294-.123.388-.127.093-.259.09-.396-.01L10 15.675zM9.458 3.324v6.671l.542.455.542-.455V3.324H9.458z",
    fill: "#fff",
    fillOpacity: 0.5
  })));
}
export default SvgRanking;